import { Component, Input } from "@angular/core";
import { MagicCardForStats, MagicSetForStats } from "@apiserver-rest/ponder-data-client-base";
import { MagicCollectionSetComponent } from "./magic-collection-set.component";
import { environment } from "../../../../../environments/environment";

@Component({
    selector: "magic-collection-sets",
    imports: [MagicCollectionSetComponent],
    templateUrl: "./magic-collection-sets.component.html"
})
export class MagicCollectionSetsComponent {
    @Input({ required: true }) public magicCards!: MagicCardForStats[];
    @Input({ required: true }) public magicSets!: MagicSetForStats[];

    public magicSetProgress: MagicSetProgress[] = [];
    public largeSetsOnly: boolean = false;

    public mythicColor: string = environment.colors.magic.mythic;
    public rareColor: string = environment.colors.magic.rare;
    public uncommonColor: string = environment.colors.magic.uncommon;

    public mythicCount: number = 0;
    public rareCount: number = 0;
    public uncommonCount: number = 0;

    public ngOnInit(): void {
        var magicSetProgressMap = new Map<string, MagicSetProgress>();

        this.magicCards.forEach(mc => {
            var progress = magicSetProgressMap.get(mc.setCode!);

            if (!progress) {
                var magicSet = this.getSet(mc.setCode!);

                if (!magicSet) {
                    return;
                }

                progress = {
                    set: magicSet,
                    collectedCount: 0,
                    percentage: 0,
                    collectedNames: new Set<string>(),
                    isVisible: true
                };

                magicSetProgressMap.set(mc.setCode!, progress);
            }

            progress.collectedNames.add(mc.name!);
        });

        this.magicSetProgress = [... magicSetProgressMap.values()];

        this.magicSetProgress.forEach(p => {
            p.collectedCount = p.collectedNames.size;
            p.percentage = Math.max(1, Math.trunc(Math.min(1, Math.max(0, p.collectedCount / p.set.distinctCardCount)) * 100));
            p.collectedNames.clear();

            if (p.percentage == 100) {
                this.mythicCount++;
            } else if (p.percentage >= 85) {
                this.rareCount++;
            } else {
                this.uncommonCount++;
            }
        });

        this.magicSetProgress.sort((a: MagicSetProgress, b: MagicSetProgress) => {
            if (a.percentage == b.percentage) {
                if (a.collectedCount == b.collectedCount) {
                    return b.set.distinctCardCount - a.set.distinctCardCount;
                }
                else {
                    return b.collectedCount - a.collectedCount;
                }
            } else {
                return (a.percentage > b.percentage ? -1 : 1);
            }
        });
    }

    private getSet(code: string): MagicSetForStats | undefined {
        return this.magicSets.find((set: MagicSetForStats) => {
            return (code == set.setCode);
        });
    }

    public onFilterChange(value: string | undefined): void {
        if (!value || value.length == 0) {
            this.magicSetProgress.forEach(s => s.isVisible = true );
        } else {
            value = value.toLowerCase();

            this.magicSetProgress.forEach(s => {
                s.isVisible = (s.set.setName!.toLowerCase().indexOf(value!) >= 0) || (s.set.setCode!.indexOf(value!) >= 0);
            });
        }        
    }
}

export type MagicSetProgress = {
    set: MagicSetForStats,
    collectedCount: number,
    percentage: number,
    collectedNames: Set<string>,
    isVisible: boolean
};